import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  enctype: "multipart/form-data",
  class: "row g-3"
}
const _hoisted_4 = { class: "col-12 form-group" }
const _hoisted_5 = { class: "col-12 form-group" }
const _hoisted_6 = { class: "col-12 form-group" }
const _hoisted_7 = { class: "col-12 form-group" }
const _hoisted_8 = { class: "col-12 form-group" }
const _hoisted_9 = { class: "col-12 form-group" }
const _hoisted_10 = { class: "col-12 form-group" }
const _hoisted_11 = { class: "col-12 form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { for: "spent_title" }, "Dépense (Titre)", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "spent_title",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
            placeholder: "Dépense (Titre)"
          }, null, 512), [
            [_vModelText, _ctx.form.title]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "type" }, "Type", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.type) = $event)),
            id: "type",
            class: "form-control selectpicker",
            title: "Type"
          }, _cache[9] || (_cache[9] = [
            _createStaticVNode("<option value=\"\">Choisir une option</option><option value=\"Transport\">Transport</option><option value=\"Carburant\">Carburant</option><option value=\"Salaire\">Salaire</option><option value=\"Consomable\">Consomable</option><option value=\"Électricité/Eau\">Électricité/Eau</option><option value=\"Loyer\">Loyer</option><option value=\"Internet/Téléphone\">Internet/Téléphone</option>", 8)
          ]), 512), [
            [_vModelSelect, _ctx.form.type]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "spent_description" }, "Description", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "spent_description",
            class: "form-control",
            placeholder: "Description",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { for: "spent_amount" }, "Montant dépensé", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            id: "spent_amount",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.amount) = $event)),
            placeholder: "Montant dépensé"
          }, null, 512), [
            [_vModelText, _ctx.form.amount]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "spent_date" }, "Date de dépense", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "spent_date",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.spent_date) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.spent_date]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "mode" }, "Mode de paiement", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.pay_mode) = $event)),
            id: "mode",
            class: "form-control selectpicker",
            title: "Mode de paiement"
          }, _cache[14] || (_cache[14] = [
            _createElementVNode("option", { value: "" }, "Choisir une option", -1),
            _createElementVNode("option", { value: "Carte bancaire" }, "Carte bancaire", -1),
            _createElementVNode("option", { value: "Paiement en espèces (cash)" }, " Paiement en espèces (cash) ", -1),
            _createElementVNode("option", { value: "Virement bancaire" }, "Virement bancaire", -1)
          ]), 512), [
            [_vModelSelect, _ctx.form.pay_mode]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { for: "spent_file" }, "Justificatif (PDF/Images uniquement)", -1)),
          _createElementVNode("input", {
            type: "file",
            id: "spent_file",
            class: "form-control",
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
            accept: "image/*,application/pdf"
          }, null, 32)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-primary mt-4",
            type: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveSpent && _ctx.saveSpent(...args)))
          }, " Ajouter ")
        ])
      ])
    ])
  ]))
}